import { authClient } from "../auth-client";

/**
 * Hook to get the current authenticated user
 * Uses better-auth's useSession hook
 */
export function useAuth() {
  const { data: session, isPending, error } = authClient.useSession();

  return {
    user: session?.user || null,
    session: session || null,
    isAuthenticated: !!session,
    isLoading: isPending,
    error,
  };
}
